export default __webpack_public_path__ + "static/media/16.21f80262.png";